import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import store from './stores';
import MainLayout from './layouts/MainLayout';
import sectionsData from './data/sections.json';

// Import sections
import Hero from './components/Hero';
import Blog from './components/Blog';
import WorkExperience from './components/WorkExperience';
import Life from './components/Life';
import Contact from './components/Contact';

// Wrapper component to handle page transitions
const AnimatedRoutes = () => {
  const location = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Hero data={{ background: 'cody' }} />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/work" element={<WorkExperience />} />
        <Route path="/life" element={<Life />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Provider store={store}>
      <Router>
        <MainLayout>
          <AnimatedRoutes />
        </MainLayout>
      </Router>
    </Provider>
  );
}

export default App;